import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  toString3o7ifthqydp6e as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source) {
        super();
        this.z2i_1 = source;
      }
      g2i() {
        return this.z2i_1;
      }
      h2i(position) {
        return position < this.g2i().length ? position : -1;
      }
      v2e() {
        var source = this.g2i();
        var cpos = this.h28_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.h28_1 = cpos;
          return charToTokenClass(c);
        }
        this.h28_1 = source.length;
        return 10;
      }
      r2e() {
        var current = this.h28_1;
        if (current === -1)
          return false;
        var source = this.g2i();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.h28_1 = current;
          return this.k2i(c);
        }
        this.h28_1 = current;
        return false;
      }
      j2i() {
        var current = this.h28_1;
        if (current === -1)
          return current;
        var source = this.g2i();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.h28_1 = current;
        return current;
      }
      b2f(expected) {
        if (this.h28_1 === -1) {
          this.l2i(expected);
        }
        var source = this.g2i();
        var cpos = this.h28_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.h28_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.l2i(expected);
        }
        this.h28_1 = -1;
        this.l2i(expected);
      }
      h2f() {
        this.b2f(_Char___init__impl__6a9atx(34));
        var current = this.h28_1;
        var closingQuote = indexOf(this.g2i(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.t2e();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false ? this.h28_1 - 1 | 0 : this.h28_1;
          var s = this.h28_1 === charSequenceLength(this.g2i()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.g2i(), position));
          var tmp$ret$0 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.d2d(tmp$ret$0, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.g2i(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.g2i(), this.h28_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.h28_1 = closingQuote + 1 | 0;
        return substring(this.g2i(), current, closingQuote);
      }
      j2f(keyToMatch, isLenient) {
        var positionSnapshot = this.h28_1;
        try {
          if (!(this.v2e() === 6))
            return null;
          var firstKey = this.e2f(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.m2i();
          if (!(this.v2e() === 5))
            return null;
          return this.e2f(isLenient);
        }finally {
          this.h28_1 = positionSnapshot;
          this.m2i();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.s27_1.u29_1 ? new (StringJsonLexer())(source) : new (StringJsonLexerWithComments())(source);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
